import {gql} from '@apollo/client';
import {FRAGMENT_CLIENT_LIST} from '../Client/graphql';

export const FRAGMENT_FRIEND_LIST = gql`
  fragment FriendList on FriendType {
    id
    isAccepted
    client1 {
      ...ClientList
      interests {
        id
        theme {
          id
          name
        }
      }
    }
    client2 {
      ...ClientList
      interests {
        id
        theme {
          id
          name
        }
      }
    }
  }
  ${FRAGMENT_CLIENT_LIST}
`;

export const QUERY_FRIEND_LIST = gql`
  query FriendList($isAccepted: Boolean) {
    friendList(isAccepted: $isAccepted) {
      ...FriendList
    }
  }
  ${FRAGMENT_FRIEND_LIST}
`;

export const MUTATION_FRIEND_SAVE = gql`
  mutation FriendSave($input: FriendSaveInput!) {
    friendSave(input: $input) {
      obj {
        ...FriendList
      }
    }
  }
  ${FRAGMENT_FRIEND_LIST}
`;

export const MUTATION_FRIEND_DELETE = gql`
  mutation FriendAccept($input: FriendDeleteInput!) {
    friendDelete(input: $input) {
      obj {
        id
        client1 {
          id
          friendsCount
        }
        client2 {
          id
          friendsCount
        }
      }
    }
  }
`;
